import project1Thumbnail from "./project-1.png";
import project2Thumbnail from "./project-2.png";
import project3Thumbnail from "./project-3.png";
import project4Thumbnail from "./project-4.png";
import project5Thumbnail from "./project-5.png";
import project6Thumbnail from "./project-6.png";
import project7Thumbnail from "./project-7.png";
import project8Thumbnail from "./project-8.png";
import project9Thumbnail from "./project-9.png";
import project10Thumbnail from "./project-10.png";
import project11Thumbnail from "./project-11.png";
import project12Thumbnail from "./project-12.png";
import project13Thumbnail from "./project-13.png";
import project14Thumbnail from "./project-14.png";
import project15Thumbnail from "./project-15.png";
import project16Thumbnail from "./project-16.png";
import project17Thumbnail from "./project-17.png";
import project18Thumbnail from "./project-18.png";
import project19Thumbnail from "./project-19.png";
import project20Thumbnail from "./project-20.png";
import project21Thumbnail from "./project-21.png";
import project22Thumbnail from "./project-22.png";
import project23Thumbnail from "./project-23.png";
import project24Thumbnail from "./project-24.png";
import project25Thumbnail from "./project-25.png";
import project26Thumbnail from "./project-26.png";
import project27Thumbnail from "./project-27.png";
import project28Thumbnail from "./project-28.png";
import project29Thumbnail from "./project-29.png";
import project30Thumbnail from "./project-30.png";

/* Types */
interface ProjectThumbnails {
  [key: string]: string;
}

/*
 * Project Thumbnails
 * This allows us to map the thumbnailName provided by the API to the actual image
 */
export const projectThumbnails: ProjectThumbnails = {
  "project-1": project1Thumbnail,
  "project-2": project2Thumbnail,
  "project-3": project3Thumbnail,
  "project-4": project4Thumbnail,
  "project-5": project5Thumbnail,
  "project-6": project6Thumbnail,
  "project-7": project7Thumbnail,
  "project-8": project8Thumbnail,
  "project-9": project9Thumbnail,
  "project-10": project10Thumbnail,
  "project-11": project11Thumbnail,
  "project-12": project12Thumbnail,
  "project-13": project13Thumbnail,
  "project-14": project14Thumbnail,
  "project-15": project15Thumbnail,
  "project-16": project16Thumbnail,
  "project-17": project17Thumbnail,
  "project-18": project18Thumbnail,
  "project-19": project19Thumbnail,
  "project-20": project20Thumbnail,
  "project-21": project21Thumbnail,
  "project-22": project22Thumbnail,
  "project-23": project23Thumbnail,
  "project-24": project24Thumbnail,
  "project-25": project25Thumbnail,
  "project-26": project26Thumbnail,
  "project-27": project27Thumbnail,
  "project-28": project28Thumbnail,
  "project-29": project29Thumbnail,
  "project-30": project30Thumbnail,
};
